module.exports = __webpack_public_path__ + "static/img/fan-check.afc78e1e.png";